import api from './api';

const emailAnalyticsService = {
  // Obtener estadísticas de hoy
  getCurrentStats: async () => {
    try {
      const response = await api.get('/api/EmailAnalytics/current');
      return response.data;
    } catch (error) {
      console.error('Error al obtener estadísticas actuales de emails:', error);
      throw error;
    }
  },

  // Obtener estadísticas del mes
  getMonthlyStats: async () => {
    try {
      const response = await api.get('/api/EmailAnalytics/monthly');
      return response.data;
    } catch (error) {
      console.error('Error al obtener estadísticas mensuales de emails:', error);
      throw error;
    }
  },

  // Obtener estadísticas por rango de fechas
  getRangeStats: async (startDate, endDate) => {
    try {
      const response = await api.get('/api/EmailAnalytics/range', {
        params: {
          startDate,
          endDate
        }
      });
      return response.data;
    } catch (error) {
      console.error('Error al obtener estadísticas por rango de emails:', error);
      throw error;
    }
  },

  // Obtener resumen rápido
  getSummary: async () => {
    try {
      const response = await api.get('/api/EmailAnalytics/summary');
      return response.data;
    } catch (error) {
      console.error('Error al obtener resumen de emails:', error);
      throw error;
    }
  }
};

export default emailAnalyticsService;
